import { tokenVar } from '../../theme/tokenVar'

export type ColorScheme = 'dark' | 'light'

// Hex values resolved from design tokens — wavesurfer renders to <canvas>,
// so CSS variables cannot be used for bar/progress/cursor colors.
const darkColors = {
  bar: '#4d6978', // icon.secondary (darkBlue.300)
  barProgress: '#ddfe55', // icon.active (signalYellow.400)
  cursor: '#a8c7e3', // text.link (dawnBlue.300)
  bg: tokenVar('colors.bg.input'), // applied to container div, not canvas
}

const lightColors = {
  bar: '#94A3B8', // light.icon.secondary
  barProgress: '#14B8A6', // light.interactive.primary
  cursor: '#3D7FCE', // light.text.link (accent.blue)
  bg: tokenVar('colors.light.bg.input'), // applied to container div
}

export const getWaveformColors = (colorScheme: ColorScheme = 'dark') =>
  colorScheme === 'light' ? lightColors : darkColors

export const containerStyles = (colorScheme: ColorScheme = 'dark') => ({
  background: colorScheme === 'light' ? lightColors.bg : darkColors.bg,
  height: '36px',
  minWidth: 0,
  paddingTop: '3px',
  position: 'relative' as const,
  flex: '1 0 0',
})
